import React from 'react';
import { Pill } from 'lucide-react';
import { PharmacyTable } from './PharmacyTable';
import type { SettingsSectionItem } from '~/libraries/settings/SettingsSection';
import { LibrarySection } from '../shared/LibrarySection';
import { useNavigate } from 'react-router-dom';

export const PharmacyLibrarySection = {
	settingsView: 'pharmacies',
	title: 'Pharmacies',
	description: 'Manage pharmacy locations and contact information',
	TitleIcon: Pill
} satisfies SettingsSectionItem;

export function PharmacyLibrary() {
	const navigate = useNavigate();
	const handleAdd = () => {
		navigate('add');
	};

	return (
		<LibrarySection
			librarySection={PharmacyLibrarySection}
			handleAdd={handleAdd}
			addLabel="Add Pharmacy"
			searchPlaceholder="Search pharmacies by name, city, or address..."
			noResultsLabel="No Pharmacies Found"
			noResultsSubLabel="Get started by adding your first pharmacy"
			TableComponent={PharmacyTable}
		/>
	);
}
